import Vue from 'vue'
import Base from '@/components/layout/base'

import 'animate.css'
import 'magic.css/assets/scss/magic.scss'
import router from '@/plugins/router'
import store from '@/plugins/store'

import '@/plugins/axios'
import '@/plugins/element-ui'
import '@/plugins/amap'
import '@/plugins/quill-editor'

import '@/utils'

import FileImage from '@/components/file-image'
import FileVideo from '@/components/file-video'
import FileDownloadButton from '@/components/file-download-button'

import { GET_FILE_LINK } from '@/utils/api'

Vue.config.productionTip = false

Vue.component('file-image', FileImage)
Vue.component('file-video', FileVideo)
Vue.component('file-download-button', FileDownloadButton)

Vue.directive('hasAuth', {
  inserted: (el, binding) => {
    const { modifiers } = binding
    const { getters: { auths }, state: {isAdminSide: admin}} = store
    if ((modifiers.admin && admin) || (!modifiers.admin)) {
      if (auths.findIndex(auth => auth.indexOf(binding.arg) !== -1) === -1) {
        el.parentNode.removeChild(el)
      }
    } else {
      el.parentNode.removeChild(el)
    }
  }
})

new Vue({
  router,
  store,
  created () {
    const browser = this.getBrowser()
    console.log('%c   当前版本号为：' + process.env.VUE_APP_VERSION + '   ', 'background:#000;color:#00EC00')
    console.log('%c   您所使用的浏览器及浏览器版本为：' + browser.browser + '/' + browser.version + '   ', 'background:#02C874;color:#A6FFFF')

    window.onbeforeunload = (e) => {
      this.$store.dispatch('tabClose')
    }
  },
  methods: {
    getBrowser () {
      const browser = {}
      const userAgent = navigator.userAgent.toUpperCase()
      const m = userAgent.match(/(MSIE|FIREFOX|CHROME|OPERA|VERSION).*?([\d.]+)/)
      browser.browser = m[1].replace(/VERSION/, 'SAFARI')
      browser.version = m[2]
      return browser
    }
  },
  render: h => h(Base)
}).$mount('#app')
